import { useEffect } from "react";

export default function useChatMembership(socket: any, jobId: string, participantId: string) {
  useEffect(() => {
    if (!socket || !jobId || !participantId) return;
    const payload = { jobId, participantId };
    const join = () => socket.emit("chat.join", payload);
    socket.on("connect", join);
    if (socket.connected) join();
    return () => {
      socket.off("connect", join);
      // Do not buffer stale leave events while offline; disconnect already
      // removed that connection's subscriptions on the server.
      if (socket.connected) {
        socket.emit("job:chat:typing", { jobId, recipientId: participantId, typing: false });
        socket.emit("chat.leave", payload);
      }
    };
  }, [socket, jobId, participantId]);
}
